module.exports = __webpack_public_path__ + "img/bird.e8b534df.jpg";